
<div class="bl-wrapper">
  <iframe
    class="bl-iframe"
    src="https://app.powerbi.com/reportEmbed?reportId=c0e0564f-a6f8-49c2-a2cc-8787aa81c44a&autoAuth=true&ctid=9dfb1a05-5f1d-449a-8960-62abcb479e7d"
    title="Analytics"
    allow="fullscreen"
  ></iframe>
</div>
